export interface ErrorStringOptions {
  /**
   * Scope of the message, will render inside brackets before the console message
   */
  scope?: string;
}

export const altoErrorPrefix = '@alto/ui:';

/**
 * Helper to generate error string in the form:
 * '@alto/ui: [scope] message'
 */
export const getAltoErrorString = (
  message: string,
  options?: ErrorStringOptions,
) => {
  let errorString = altoErrorPrefix;

  const { scope } = options ?? {};
  if (scope) errorString = `${errorString} [${scope}]`;

  return `${errorString} ${message}`;
};

/**
 * Helper to create an Error object with the message in the alto style
 *
 * Should be used when we want to throw an error with a helpful message before the app crashes
 */
export const AltoError = (
  message: string,
  options?: ErrorOptions & ErrorStringOptions,
) => {
  const { scope, ...errorOptions } = options ?? {};
  return new Error(getAltoErrorString(message, { scope }), errorOptions);
};
